const AwsCredentials = {
  bucketName: "workoutvideo",
  bucketForChallengeName: "workoutchallenge",
  bucketRewardBadges: "rewardbadges",
  region: "us-east-2",
  phalanxS3Bucket_dev: "phalanx-development",
  phalanxS3Bucket_stag: "phalanx-staging",
  phalanxS3Bucket: "phalanx-production",
};

export default AwsCredentials;
